import _maxBy from 'lodash/maxBy';
import _minBy from 'lodash/minBy';
/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withPropsOnChange from 'recompose/withPropsOnChange';
import pure from 'recompose/pure';
import { scaleQuantize } from 'd3-scale';
import { withTheme, withDimensions } from '../../../hocs';
import { CalendarDefaultProps } from './props';
export default (function (Component) {
  return compose(defaultProps(CalendarDefaultProps), withTheme(), withDimensions(), withPropsOnChange(['data', 'domain', 'colors'], function (_ref) {
    var data = _ref.data,
        domain = _ref.domain,
        colors = _ref.colors;
    var colorDomain = void 0;

    if (domain === 'auto') {
      colorDomain = [_minBy(data, 'value').value, _maxBy(data, 'value').value];
    } else {
      colorDomain = [].concat(domain);
    }

    var colorScale = scaleQuantize().domain(colorDomain).range(colors);
    return {
      colorScale: colorScale
    };
  }), pure)(Component);
});